<template>
    <b-modal @ok="submit" v-model="modalVisible" title="Set Officer">
        <b-form submit.prevent="submit">
            <b-form-group
                id="officer-input-group"
                label="Officer:"
                label-for="officerInput"
            >
                <b-form-select
                    id="officerInput"
                    name="officerInput"
                    v-model="driverId"
                    :options="driverOptions"
                    required
                ></b-form-select>
            </b-form-group>
        </b-form>
    </b-modal>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'

export default {
    name: 'change-orders-driver',
    props: ['orders'],
    mixins: [popupMixins],
    data: () => {
        return {
            modalVisible: false,
            driverId: null,
            submitting: false,
        }
    },
    computed: {
        driverOptions() {
            return this.drivers.map(x => ({
                value: x.id,
                text: `${x.first_name} ${x.last_name}`,
            }))
        },
        drivers() {
            return this.$store.state.orders.drivers
        },
    },
    watch: {
        drivers: function (drivers) {
            if (!this.driverId && drivers.length > 0)
                this.driverId = drivers[0].id
        },
    },
    created() {},
    methods: {
        show() {
            this.modalVisible = true
            this.driverId = null
        },
        close() {
            this.modalVisible = false
        },
        cancel() {
            this.modalVisible = false
        },
        submit() {
            this.submitting = true
            this.$store
                .dispatch('orders/bulkSetDriver', {
                    orders: this.orders,
                    driverId: this.driverId,
                })
                .then(() => {
                    this.doToast(
                        'Success!',
                        'Selected orders were marked as complete',
                        'success'
                    )

                    this.$emit('success')
                    this.modalVisible = false
                })
                .catch(err => {
                    console.error(err)
                    this.doToast(
                        'Error!',
                        'There was an error marking orders as complete',
                        'warning'
                    )

                    this.$emit('error')
                    this.modalVisible = false
                })
                .finally(() => {
                    this.submitting = false
                })
        },
    },
    mounted() {
        this.$store.dispatch('orders/fetchDrivers')
    },
}
</script>
